import React from 'react';
import PropTypes from 'prop-types';
import * as Styled from './styles';
import {
    affIds,
    BET,
    buildTransferLink,
    dcmpTags
} from '../../../helpers/transfers';
import { getSelectionPromotionConfig } from '../../../helpers/promotions';
import { useAuth } from '../../../hooks/useAuth';
import { useSportConfig } from '../../../hooks/useSportConfig';
import { usePromotions } from '../../../hooks/usePromotions';

const transferLink = (eventPath, isLoggedIn) => {
    return buildTransferLink({
        to: BET,
        dcmp: dcmpTags.selection,
        affId: affIds.selection,
        event: eventPath,
        isLoggedIn
    });
};

const SelectionAssigned = ({
    title,
    selection,
    excludeFromBetting,
    bettingEnabled
}) => {
    const { authStore } = useAuth();
    const { config, SelectionCard, mapSelectionToCardProps } = useSportConfig();
    const { promotions } = usePromotions();

    const heading = config.labels.assignedTitle(title);
    const cardProps = mapSelectionToCardProps(selection);

    const selectionPromoConfig = getSelectionPromotionConfig({
        promotions
    });

    const showSkybetLink =
        !excludeFromBetting && bettingEnabled && selectionPromoConfig.enabled;

    const skybetLinkHref =
        showSkybetLink && selectionPromoConfig.enabled
            ? transferLink(selectionPromoConfig.eventPath, authStore.loggedIn)
            : undefined;

    return (
        <div>
            <Styled.Heading>{heading}</Styled.Heading>
            <div>
                <SelectionCard
                    // eslint-disable-next-line react/jsx-props-no-spreading
                    {...cardProps}
                    showSkybetLink={showSkybetLink}
                    skybetLinkHref={skybetLinkHref}
                />
            </div>
        </div>
    );
};

SelectionAssigned.defaultProps = {
    selection: { name: '-', metaData: {} }
};

SelectionAssigned.propTypes = {
    title: PropTypes.string.isRequired,
    selection: PropTypes.shape({
        name: PropTypes.string,
        metaData: PropTypes.shape({})
    }),
    excludeFromBetting: PropTypes.bool.isRequired,
    bettingEnabled: PropTypes.bool.isRequired
};

export default SelectionAssigned;
